import { FontFamily, LayoutId, SupportedReligion } from "@/enum";
import { Template } from "@/types";
import MBM_001 from "public/templates/thumbnail/MBM_001.jpg";
import MBM_002 from "public/templates/thumbnail/MBM_002.jpg";
import MBM_003 from "public/templates/thumbnail/MBM_003.jpg";
import MBM_004 from "public/templates/thumbnail/MBM_004.jpg";
import MBM_005 from "public/templates/thumbnail/MBM_005.jpg";
import MBM_006 from "public/templates/thumbnail/MBM_006.jpg";
import MBM_007 from "public/templates/thumbnail/MBM_007.jpg";
import MBM_008 from "public/templates/thumbnail/MBM_008.jpg";
import MBM_009 from "public/templates/thumbnail/MBM_009.jpg";
import MBM_010 from "public/templates/thumbnail/MBM_010.jpg";
import MBM_011 from "public/templates/thumbnail/MBM_011.jpg";
import MBM_012 from "public/templates/thumbnail/MBM_012.jpg";
import MBM_013 from "public/templates/thumbnail/MBM_013.jpg";
import MBM_014 from "public/templates/thumbnail/MBM_014.jpg";
import MBM_015 from "public/templates/thumbnail/MBM_015.jpg";
import MBM_016 from "public/templates/thumbnail/MBM_016.jpg";
import MBM_017 from "public/templates/thumbnail/MBM_017.jpg";
import MBM_018 from "public/templates/thumbnail/MBM_018.jpg";
import MBM_019 from "public/templates/thumbnail/MBM_019.jpg";
import MBM_020 from "public/templates/thumbnail/MBM_020.jpg";
import MBM_021 from "public/templates/thumbnail/MBM_021.jpg";
import MBM_022 from "public/templates/thumbnail/MBM_022.jpg";
import MBM_023 from "public/templates/thumbnail/MBM_023.jpg";
import MBM_024 from "public/templates/thumbnail/MBM_024.jpg";
import MBM_025 from "public/templates/thumbnail/MBM_025.jpg";
import MBM_026 from "public/templates/thumbnail/MBM_026.jpg";
import MBM_027 from "public/templates/thumbnail/MBM_027.jpg";
import MBM_028 from "public/templates/thumbnail/MBM_028.jpg";
import MBM_029 from "public/templates/thumbnail/MBM_029.jpg";
import MBM_030 from "public/templates/thumbnail/MBM_030.jpg";
import MBM_031 from "public/templates/thumbnail/MBM_031.jpg";
import MBM_032 from "public/templates/thumbnail/MBM_032.jpg";
import MBM_033 from "public/templates/thumbnail/MBM_033.jpg";
import MBM_034 from "public/templates/thumbnail/MBM_034.jpg";
import MBM_035 from "public/templates/thumbnail/MBM_035.jpg";
import MBM_036 from "public/templates/thumbnail/MBM_036.jpg";
import MBM_037 from "public/templates/thumbnail/MBM_037.jpg";
import MBM_038 from "public/templates/thumbnail/MBM_038.jpg";
import MBM_039 from "public/templates/thumbnail/MBM_039.jpg";
import MBM_040 from "public/templates/thumbnail/MBM_040.jpg";
import MBM_041 from "public/templates/thumbnail/MBM_041.jpg";
import MBM_042 from "public/templates/thumbnail/MBM_042.jpg";
import MBM_043 from "public/templates/thumbnail/MBM_043.jpg";
import MBM_044 from "public/templates/thumbnail/MBM_044.jpg";
import MBM_045 from "public/templates/thumbnail/MBM_045.jpg";
import MBM_046 from "public/templates/thumbnail/MBM_046.jpg";
import MBM_047 from "public/templates/thumbnail/MBM_047.jpg";
import MBM_048 from "public/templates/thumbnail/MBM_048.jpg";
import MBM_049 from "public/templates/thumbnail/MBM_049.jpg";
import MBM_050 from "public/templates/thumbnail/MBM_050.jpg";
import MBM_051 from "public/templates/thumbnail/MBM_051.jpg";
import MBM_052 from "public/templates/thumbnail/MBM_052.jpg";
import MBM_053 from "public/templates/thumbnail/MBM_053.jpg";
import MBM_054 from "public/templates/thumbnail/MBM_054.jpg";
import MBM_055 from "public/templates/thumbnail/MBM_055.jpg";
import MBM_056 from "public/templates/thumbnail/MBM_056.jpg";
import MBM_057 from "public/templates/thumbnail/MBM_057.jpg";
import MBM_058 from "public/templates/thumbnail/MBM_058.jpg";
import MBM_059 from "public/templates/thumbnail/MBM_059.jpg";
import MBM_060 from "public/templates/thumbnail/MBM_060.jpg";

export const TEMPLATE_LIST: Template[] = [
  {
    id: "MBM_039",
    src: MBM_039,
    price: 0,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 75,
      Y_HEADER_TEXT_START: 75,
      Y_HEADER_TEXT_END: 75,
      Y_TEXT_START: 120,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#000000",
      TEXT_COLOR: "#000000",
    },
  },
    {
    id: "MBM_001",
    src: MBM_001,
    price: 49,
    isTrending: true,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 932,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#A4592C",
      TEXT_COLOR: "#000000",
    },
  },
  {
    // Two-column layout (TwoColumnLayout) — Muslim biodata template.
    id: "MBM_058",
    src: MBM_058,
    price: 49,
    isTrending: false,
    religions: [SupportedReligion.Islam],
    layoutId: LayoutId.TWO_COLUMN,
    metadata: {
      X_PAGE_START: 50,
      X_PAGE_END: 744,
      Y_HEADER_ICON_START: 196,
      Y_HEADER_ICON_END: 401,
      Y_HEADER_TEXT_START: 455,
      Y_HEADER_TEXT_END: 500,
      Y_TEXT_START: 560,
      Y_TEXT_END: 1089,
      DP_WIDTH: 205,
      DP_HEIGHT: 205,
      THEME_COLOR: "#de6812",
      TEXT_COLOR: "#000000",
      TEXT_FONT_SIZE: 11,
      FONT_FAMILY: FontFamily.GELASIO,
    },
  },
  {
    id: "MBM_016",
    src: MBM_016,
    price: 49,
    isTrending: true,
    metadata: {
      X_PAGE_START: 90,
      X_PAGE_END: 704,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 960,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#E7A581",
      TEXT_COLOR: "#494949",
    },
  },
  {
    id: "MBM_002",
    src: MBM_002,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 932,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#A4592C",
      TEXT_COLOR: "#13181c",
    },
  },
  {
    id: "MBM_056",
    src: MBM_056,
    price: 29,
    isTrending: true,
    metadata: {
      X_PAGE_START: 90,
      X_PAGE_END: 704,
      Y_HEADER_ICON_START: 100,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1023,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#536653",
      TEXT_COLOR: "#494949",
    },
  },
  {
    id: "MBM_057",
    src: MBM_057,
    price: 29,
    isTrending: true,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#8AAFA2",
      TEXT_COLOR: "#494949",
    },
  },
  {
    id: "MBM_049",
    src: MBM_049,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1080,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#af865c",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_060",
    src: MBM_060,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1020,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#542e18",
      TEXT_COLOR: "#272727",
    },
  },

    {
    // Arch layout (ArchLayout): photo + name, full-width About Me, two columns,
    // full-width Expectations.
    id: "MBM_059",
    src: MBM_059,
    price: 49,
    isTrending: false,
    layoutId: LayoutId.ARCH,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 145,
      Y_HEADER_ICON_END: 390,
      Y_HEADER_TEXT_START: 400,
      Y_HEADER_TEXT_END: 440,
      Y_TEXT_START: 585,
      Y_TEXT_END: 980,
      DP_WIDTH: 245,
      DP_HEIGHT: 245,
      THEME_COLOR: "#339080",
      TEXT_COLOR: "#1a1a1a",
      TEXT_FONT_SIZE: 11,
      FONT_FAMILY: FontFamily.GELASIO,
    },
  },
  {
    id: "MBM_050",
    src: MBM_050,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1080,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#a48b48",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_051",
    src: MBM_051,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1080,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#9f4913",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_054",
    src: MBM_054,
    price: 29,
    isTrending: false,
    religions: [SupportedReligion.Sikhism],
    metadata: {
      X_PAGE_START: 55,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1070,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#d6b368",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_052",
    src: MBM_052,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1000,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#c48532",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_053",
    src: MBM_053,
    price: 39,
    isTrending: false,
    religions: [SupportedReligion.Sikhism],
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1020,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#c29b4a",
      TEXT_COLOR: "#272727",
    },
  },
  {
    id: "MBM_048",
    src: MBM_048,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#694b1f",
      TEXT_COLOR: "#000000",
      CUSTOM_STYLES: {
        title: {
          minWidth: "30%",
          display: "flex",
          alignSelf: "flex-start",
          color: "#fff8ea",
          padding: "2px 2px 2px 8px",
          backgroundColor: "#694b1f",
          borderRadius: 2,
          textAlign: "center",
        },
      },
    },
  },
  {
    id: "MBM_040",
    src: MBM_040,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#8c3e08",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_003",
    src: MBM_003,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 74,
      X_PAGE_END: 720,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#CF6950",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_004",
    src: MBM_004,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#28245B",
      TEXT_COLOR: "#000000",
    },
  },

  {
    id: "MBM_031",
    src: MBM_031,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#000000",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_032",
    src: MBM_032,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#000000",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_033",
    src: MBM_033,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#000000",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_034",
    src: MBM_034,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 100,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1023,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#231F20",
      TEXT_COLOR: "#231F20",
    },
  },
  {
    id: "MBM_035",
    src: MBM_035,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#1A1A1A",
      TEXT_COLOR: "#1A1A1A",
    },
  },
  {
    id: "MBM_036",
    src: MBM_036,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#000000",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_037",
    src: MBM_037,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 960,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#6B646B",
      TEXT_COLOR: "#585158",
    },
  },
  {
    id: "MBM_005",
    src: MBM_005,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 60,
      X_PAGE_END: 734,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#3D752A",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_006",
    src: MBM_006,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 914,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#EEBA2B",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_007",
    src: MBM_007,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 950,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#8CC3C4",
      TEXT_COLOR: "#27464E",
    },
  },
  {
    id: "MBM_008",
    src: MBM_008,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#EEBA2B",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_009",
    src: MBM_009,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#565A5B",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_010",
    src: MBM_010,
    price: 29,
    isTrending: true,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#644F59",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_011",
    src: MBM_011,
    price: 29,
    isTrending: true,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#A3720F",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_012",
    src: MBM_012,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#80736F",
      TEXT_COLOR: "#332A24",
    },
  },
  {
    id: "MBM_013",
    src: MBM_013,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 90,
      X_PAGE_END: 704,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1038,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#EAA416",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_014",
    src: MBM_014,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#EB98A0",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_015",
    src: MBM_015,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#6D876D",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_017",
    src: MBM_017,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#CB182D",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_018",
    src: MBM_018,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 70,
      X_PAGE_END: 724,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#FFFBFA",
      TEXT_COLOR: "#EFEEE9",
    },
  },
  {
    id: "MBM_019",
    src: MBM_019,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#222222",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_022",
    src: MBM_022,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#F8AC39",
      TEXT_COLOR: "#545454",
    },
  },
  {
    id: "MBM_023",
    src: MBM_023,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#E39BA7",
      TEXT_COLOR: "#545454",
    },
  },
  {
    id: "MBM_020",
    src: MBM_020,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 960,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#F1D780",
      TEXT_COLOR: "#B6C2CE",
    },
  },
  {
    id: "MBM_042",
    src: MBM_042,
    price: 29,
    isTrending: true,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 115,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#ffe3be",
      TEXT_COLOR: "#EFEEE9",
    },
  },
  {
    id: "MBM_041",
    src: MBM_041,
    price: 39,
    isTrending: true,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 60,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 960,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#FFD38C",
      TEXT_COLOR: "#EFEEE9",
    },
  },
  {
    id: "MBM_044",
    src: MBM_044,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 85,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#ffcd86",
      TEXT_COLOR: "#EFEEE9",
    },
  },
  {
    id: "MBM_045",
    src: MBM_045,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 85,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#ffbd59",
      TEXT_COLOR: "#EFEEE9",
    },
  },
  {
    id: "MBM_021",
    src: MBM_021,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 85,
      X_PAGE_END: 709,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#E3D5B8",
      TEXT_COLOR: "#B3AA99",
    },
  },
  {
    id: "MBM_047",
    src: MBM_047,
    price: 39,
    isTrending: false,
    disableProfilePicture: true,
    religions: [SupportedReligion.Islam],
    metadata: {
      X_PAGE_START: 150,
      X_PAGE_END: 644,
      Y_HEADER_ICON_START: 150,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1080,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#efd284",
      TEXT_COLOR: "#ededcd",
      CUSTOM_STYLES: {
        title: {
          textAlign: "center",
          borderRadius: 10,
          color: "#025443",
          backgroundColor: "#efd284",
        },
      },
    },
  },
  {
    id: "MBM_024",
    src: MBM_024,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 264,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#3D7933",
      TEXT_COLOR: "#000000",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_025",
    src: MBM_025,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 200,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#C0954A",
      TEXT_COLOR: "#273D2A",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_026",
    src: MBM_026,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 90,
      X_PAGE_END: 704,
      Y_HEADER_ICON_START: 110,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 932,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#3D752A",
      TEXT_COLOR: "#545454",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_027",
    src: MBM_027,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 170,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 945,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#675D5C",
      TEXT_COLOR: "#545454",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_028",
    src: MBM_028,
    price: 49,
    isTrending: true,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 885,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#F9F4ED",
      TEXT_COLOR: "#D9D9D9",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_029",
    src: MBM_029,
    price: 49,
    isTrending: false,
    metadata: {
      X_PAGE_START: 65,
      X_PAGE_END: 729,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#F1D780",
      TEXT_COLOR: "#D9D9D9",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_030",
    src: MBM_030,
    price: 39,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1048,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#6A6025",
      TEXT_COLOR: "#694B1F",
    },
    religions: [SupportedReligion.Islam],
  },
  {
    id: "MBM_046",
    src: MBM_046,
    price: 49,
    isTrending: false,
    religions: [SupportedReligion.Islam],
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 85,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1020,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#493812",
      TEXT_COLOR: "#614a18",
    },
  },
  {
    id: "MBM_038",
    src: MBM_038,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 990,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#8C8561",
      TEXT_COLOR: "#545143",
    },
    religions: [SupportedReligion.Buddhism],
  },
  {
    id: "MBM_055",
    src: MBM_055,
    price: 29,
    isTrending: false,
    religions: [SupportedReligion.Buddhism],
    metadata: {
      X_PAGE_START: 80,
      X_PAGE_END: 714,
      Y_HEADER_ICON_START: 100,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 1023,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#061bb0",
      TEXT_COLOR: "#000000",
    },
  },
  {
    id: "MBM_043",
    src: MBM_043,
    price: 29,
    isTrending: false,
    metadata: {
      X_PAGE_START: 54,
      X_PAGE_END: 740,
      Y_HEADER_ICON_START: 75,
      Y_HEADER_ICON_END: 136,
      Y_HEADER_TEXT_START: 144,
      Y_HEADER_TEXT_END: 170,
      Y_TEXT_START: 200,
      Y_TEXT_END: 932,
      DP_WIDTH: 203,
      DP_HEIGHT: 270,
      THEME_COLOR: "#061bb0",
      TEXT_COLOR: "#13181c",
    },
    religions: [SupportedReligion.Buddhism],
  },
];
